import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Provide, Ref, Watch } from 'vue-property-decorator';

import { DesignerStateProvider } from '../../designer.provider';
import { IDesignerElementSize } from '../../models/designer-element.model';


@Component({
  name: 'ed-designer',
  components: {
    EdDesignerCanvas: () => import(/* webpackChunkName: "ed-designer-canvas" */ '../ed-designer-canvas/ed-designer-canvas.component.vue'),
    EdDesignerMenu: () => import(/* webpackChunkName: "ed-designer-menu" */ '../ed-designer-menu/ed-designer-menu.component.vue'),
    EdDesignerElements: () => import(/* webpackChunkName: "ed-designer-elements" */ '../ed-designer-elements/ed-designer-elements.component.vue'),
    EdDesignerElementsTools: () => import(/* webpackChunkName: "ed-designer-elements-tools" */ '../ed-designer-elements-tools/ed-designer-elements-tools.component.vue'),
  }
})
export default class EdDesignerComponent extends Vue {
  @Prop({ default: false }) readonly usingCustomCanvas: boolean;
  @Prop({ default: '' }) readonly containerId: string;
  @Prop({ default: true }) readonly hasTopBarMenu: boolean;
  @Prop({ default: false }) readonly disabled: boolean;
  @Prop({ default: null }) readonly sizes: IDesignerElementSize;

  @Ref('customCanvasContainer') readonly customCanvasContainer!: any;
  @Ref('defaultCanvasContainer') readonly defaultCanvasContainer!: any;
  @Ref('designerCanvas') readonly designerCanvas!: any;

  @Emit('change')
  emitChange() {
    return {
      elements: this.elementsFormatted,
    };
  }

  @Provide()
  readonly DesignerStateProvider = new DesignerStateProvider();

  defaultContainerId: string = 'canvas-container';

  get elementsFormatted() {
    return this.DesignerStateProvider.elements?.map((e, i) => e.getElementToSaveFormatted());
  }

  mounted() {
    this.initCanvas();
    this.setContainerSizes();
  }

  initCanvas() {
    const customChildContainer = document.getElementById(this.containerId);
    const isCustomContainerExist = this.customCanvasContainer?.children?.length > 0;
    const isCustomChildContainerExist = this.containerId ? !!customChildContainer : false;
    
    if (this.usingCustomCanvas && isCustomContainerExist) {

      if (isCustomChildContainerExist) {
        this.setOnCustomContainer(customChildContainer);
        
        this.DesignerStateProvider.containerId = this.containerId;
      } else {
        this.setOnCustomContainer(this.customCanvasContainer.children[0]);

        this.DesignerStateProvider.containerId = this.defaultContainerId;
      }
      
      return;
    }

    this.setOnDefaultContainer();
  }

  setOnDefaultContainer() {
    this.defaultCanvasContainer.innerHTML = '';
    this.defaultCanvasContainer.appendChild(this.designerCanvas);
    this.DesignerStateProvider.containerId = this.defaultContainerId;
  }

  setOnCustomContainer(customChildContainer) {
    customChildContainer.innerHTML = '';
    customChildContainer.appendChild(this.designerCanvas);
  }

  loadDesign({ elements }) {
    this.cleanCanvas();
    this.initCanvas();

    if (elements) {
      this.DesignerStateProvider.setElementsFromJson(elements);
    }
  }

  cleanCanvas() {
    this.DesignerStateProvider.elements = [];
    this.DesignerStateProvider.elementSelected = null;
  }

  clearSelection() {
    this.DesignerStateProvider.clearSelection();
  }

  setContainerSizes() {
    this.DesignerStateProvider.containerHeight = this.sizes?.height || 434;
    this.DesignerStateProvider.containerWidth = this.sizes?.width || 700;
  }

  @Watch('elementsFormatted', { deep: true })
  onElementsFormattedChanged() {
    this.emitChange();
  }
}